import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './LegendTermsConditions.style.scss';

export const LegendTermsConditions = () => {
  return (
    <div className="legend-terms-conditions">
      <DynamicContent
        configPath={REMOTE_CONFIG_PATHS.TERMS_CONDITIONS.LEGEND}
        renderAsHtml={true}
      />
    </div>
  );
};
